import { getHash } from './math'
const handlers = {}

export function listenToTransitionEnd(element, animatedProps, callback, options = {}) {
  if (!element.uniqueHashId) element.uniqueHashId = getHash()
  if (handlers[element.uniqueHashId]) return

  handlers[element.uniqueHashId] = e => {
    const isAnimatedProperty = animatedProps.some(prop => e.propertyName === prop)

    if (e.target === element && isAnimatedProperty) {
      if (options.once) {
        element.removeEventListener('transitionend', handlers[element.uniqueHashId])
        delete handlers[element.uniqueHashId]
      }
      callback()
    }
  }
  element.addEventListener('transitionend', handlers[element.uniqueHashId])
}

export function listenToTransitionEndOnce(element, animatedProps, callback) {
  listenToTransitionEnd(element, animatedProps, callback, { once: true })
}
